import React from "react";
import Hero from "../components/joinUs/Hero";
import Join from "../components/joinUs/join";
import JobList from "../components/jobOpenenings/openings"
import { Helmet } from "react-helmet-async";
import CultureComponent from "../components/joinUs/OurCulture";
const JoinUs = () => {
  return (
    <>
      {/*metadata for SEO */}
      <Helmet>
        <title>Join Us | DevAngles</title>
        <meta name="description" content="Find your next career at DevAgles and join our team to achieve your professional goals." />
        
        <link rel="canonical" href="https://www.devangles.com/joinus/" />
        <link rel="dns-prefetch" href="https://www.devangles.com" />
        <link rel="dns-prefetch" href="//fonts.googleapis.com" />
      </Helmet>
      <Hero />
      <Join />

<CultureComponent/>
      <JobList />

    </>
  );
};

export default JoinUs;
